module.exports = __webpack_public_path__ + "img/block-1920.5943959c.jpg";